module.exports = __webpack_public_path__ + "static/media/img_W_kids.185ee4ee.png";